import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface SetDocumentTypeParams {
  documentId: string;
  loanId?: string;
  type: string;
}

export interface SetDocumentTypeResponse {
  document: {
    id: string;
    document_type_id: string;
    loan_id: string;
  };
}

const setDocumentType: MutationFunction<
  SetDocumentTypeResponse,
  SetDocumentTypeParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockType);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<SetDocumentTypeResponse>(
    `/documents/${args.documentId}`,
    {
      method: 'PUT',
      body: {
        documentTypeId: args.type,
        userApproved: true,
      },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to set document type');
};

export default setDocumentType;

const _mockType = {
  document: {
    id: 'mock-document-id',
    document_type_id: 'mock-document-type-id',
    loan_id: 'mock-loan-id',
  },
};
